/**
 * @generated SignedSource<<b7f951b0c8c256682bae1d46d09e2cf2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppTab_container$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AppTabMenu_container" | "TabWithMenu_container">;
  readonly " $fragmentType": "AppTab_container";
};
export type AppTab_container$key = {
  readonly " $data"?: AppTab_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppTab_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AppTab_container",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TabWithMenu_container"
    },
    {
      "kind": "FragmentSpread",
      "name": "AppTabMenu_container"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "8257e51a0537d2533d3cb266fbb85918";

export default node;
